(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-welcome-popup"]) return;
  try {
    

  (function () {
    /* Isolated: any error here only disables the popup, never the page */
    try { init(); } catch (err) { if (window.console) console.warn('[of-sp]', err); }

    function init() {
      var root = document.getElementById('of-sp');
      if (!root) return;

      var KEYS = {
        subscribed: 'of_sp_subscribed',
        dismissedAt: 'of_sp_dismissed_at',
        shownThisVisit: 'of_sp_shown_visit',
        visitStart: 'of_sp_visit_start'
      };
      var DAY = 86400000;
      var REVEAL_AT = 0.6; /* share of the foil scratched before the email field appears */
      var params = new URLSearchParams(location.search);
      var testMode = params.get('hs_popup') === 'test';
      var pending = get('sessionStorage','hs_sp_pending') === '1';
      var postSuccess = pending && !!root.querySelector('[data-hs-welcome-success]');
      var postError = pending && !!root.querySelector('[data-hs-welcome-error]');

      function get(store, key) { try { return window[store].getItem(key); } catch (e) { return null; } }
      function set(store, key, val) { try { window[store].setItem(key, val); } catch (e) {} }

      /* Known subscribers: arrived from a Klaviyo email, or just used the footer signup */
      var utmSource = (params.get('utm_source') || '').toLowerCase();
      if (params.has('_kx') || utmSource.indexOf('klaviyo') > -1 || params.get('utm_medium') === 'email' || params.get('customer_posted') === 'true') {
        set('localStorage', KEYS.subscribed, '1');
      }

      if (!testMode && !postSuccess && !postError) {
        if (window.Shopify && Shopify.designMode) return;
        if (get('localStorage', KEYS.subscribed)) return;
        if (get('sessionStorage', KEYS.shownThisVisit)) return;
        var dismissedAt = Number(get('localStorage', KEYS.dismissedAt) || 0);
        if (dismissedAt && Date.now() - dismissedAt < Number(root.dataset.snoozeDays) * DAY) return;
      }

      var panel = root.querySelector('.of-sp__panel');
      var offer = root.querySelector('[data-of-sp-step="offer"]');
      var success = root.querySelector('[data-of-sp-step="success"]');
      var title = root.querySelector('[data-of-sp-title]');
      var form = root.querySelector('.of-sp__form');
      var input = root.querySelector('#of-sp-email');
      var error = root.querySelector('.of-sp__error');
      var submit = form.querySelector('button[type="submit"]');
      var canvas = root.querySelector('.of-sp__foil');
      var ctx = canvas.getContext ? canvas.getContext('2d') : null;
      var opened = false;
      var revealed = false;
      var subscribed = false;
      var lastFocus = null;

      /* ---- Triggers ---- */

      /* Timer counts from the first allowed page of this visit. Advertorials skip it. */
      var start = Number(get('sessionStorage', KEYS.visitStart) || 0);
      if (!start) { start = Date.now(); set('sessionStorage', KEYS.visitStart, String(start)); }
      var wait = testMode ? 1000 : Math.max(0, Number(root.dataset.delay) * 1000 - (Date.now() - start));
      if (testMode || root.dataset.exitOnly !== 'true') setTimeout(openWhenFree, wait);

      /* Exit intent: can open it before the timer. Armed after 3s on the page. */
      setTimeout(function () {
        if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          /* Desktop: pointer leaves through the top of the window (tabs, address bar, close) */
          document.addEventListener('mouseout', function (e) {
            if (!e.relatedTarget && e.clientY <= 0) openOnExit();
          });
        } else {
          /* Phones: a fast scroll back up after reading down the page */
          var lastY = window.scrollY, lastT = Date.now(), maxY = lastY;
          window.addEventListener('scroll', function () {
            var y = window.scrollY, t = Date.now();
            maxY = Math.max(maxY, y);
            var speed = (lastY - y) / Math.max(1, t - lastT); /* px per ms, upward */
            if (maxY > 600 && lastY - y > 60 && speed > 1.5) openOnExit();
            lastY = y; lastT = t;
          }, { passive: true });
        }
      }, testMode ? 0 : 3000);

      function openOnExit() {
        if (!opened && !busy()) open();
      }

      var tries = 0;
      function openWhenFree() {
        if (opened) return;
        if (busy()) { if (++tries < 30) setTimeout(openWhenFree, 2000); return; }
        open();
      }

      /* Don't interrupt: skip while the cart drawer or any other modal is on screen */
      function isVisible(el) {
        if (!el || !el.getClientRects().length) return false;
        var st = getComputedStyle(el);
        if (st.display === 'none' || st.visibility === 'hidden' || Number(st.opacity) === 0) return false;
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth;
      }
      function busy() {
        if (document.querySelector('cart-drawer.active, cart-drawer.is-visible')) return true;
        if (document.querySelector('details[open] > .modal__content, details[open] > .menu-drawer')) return true;
        /* includes Shopify's cookie consent banner (role="alertdialog"): let them answer it first */
        var dialogs = document.querySelectorAll('[aria-modal="true"], [role="dialog"], [role="alertdialog"]');
        for (var i = 0; i < dialogs.length; i++) {
          if (!root.contains(dialogs[i]) && isVisible(dialogs[i])) return true;
        }
        return isVisible(document.getElementById('cw-popup-pdp-overlay'));
      }

      /* ---- Open / close ---- */

      function open() {
        if (opened) return;
        opened = true;
        set('sessionStorage', KEYS.shownThisVisit, '1');
        lastFocus = document.activeElement;
        try {
          root.hidden = false;
          document.documentElement.classList.add('of-sp-lock');
          watchViewport(true);
          drawFoil();
          root.querySelector('.of-sp__close').focus({ preventScroll: true });
        } catch (err) {
          /* Never leave the page locked behind a broken popup */
          root.hidden = true;
          document.documentElement.classList.remove('of-sp-lock');
          if (window.console) console.warn('[of-sp]', err);
        }
      }

      function close(isDismiss) {
        if (isDismiss && !subscribed) set('localStorage', KEYS.dismissedAt, String(Date.now()));
        root.hidden = true;
        document.documentElement.classList.remove('of-sp-lock');
        watchViewport(false);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }

      root.querySelectorAll('[data-of-sp-dismiss]').forEach(function (el) {
        el.addEventListener('click', function () { close(true); });
      });
      root.querySelector('[data-of-sp-close]').addEventListener('click', function () { close(false); });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(true); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(
          panel.querySelectorAll('button, input, a[href], [tabindex="0"]'),
          function (el) { return isVisible(el) && !el.disabled; }
        );
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      /* ---- Scratch foil: only the visitor removes it ---- */

      var moves = 0;
      var scratching = false;
      var foilW = 0, foilH = 0; /* size the foil was drawn at */

      function drawFoil() {
        if (!ctx) { canvas.style.display = 'none'; reveal(); return; }
        var rect = canvas.getBoundingClientRect();
        var w = rect.width, h = rect.height;
        foilW = w; foilH = h;
        var dpr = window.devicePixelRatio || 1;
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.globalCompositeOperation = 'source-over';

        /* Silver foil with a light diagonal sheen */
        var g = ctx.createLinearGradient(0, 0, w, h);
        g.addColorStop(0, '#aeb3ba');
        g.addColorStop(0.45, '#e9ebee');
        g.addColorStop(0.55, '#dfe2e6');
        g.addColorStop(1, '#a4a9b1');
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, w, h);
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.35)';
        ctx.lineWidth = 2;
        for (var x = -h; x < w; x += 14) {
          ctx.beginPath();
          ctx.moveTo(x, h);
          ctx.lineTo(x + h, 0);
          ctx.stroke();
        }

        var font = getComputedStyle(root).fontFamily;
        ctx.fillStyle = '#3f444d';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = '800 26px ' + font;
        ctx.fillText('SCRATCH HERE', w / 2, h / 2);
      }

      var lastPoint = null;
      function scratchAt(e) {
        var rect = canvas.getBoundingClientRect();
        /* Scale to the drawn size, in case the card was resized since */
        var x = (e.clientX - rect.left) * foilW / rect.width;
        var y = (e.clientY - rect.top) * foilH / rect.height;
        ctx.globalCompositeOperation = 'destination-out';
        /* A continuous stroke from the last point, so fast swipes don't leave gaps */
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = 44;
        ctx.strokeStyle = '#000'; /* fully opaque, so the stroke removes the foil completely */
        ctx.beginPath();
        ctx.moveTo(lastPoint ? lastPoint.x : x, lastPoint ? lastPoint.y : y);
        ctx.lineTo(x, y);
        ctx.stroke();
        lastPoint = { x: x, y: y };
        if (!revealed && ++moves % 6 === 0 && clearedRatio() >= REVEAL_AT) reveal();
      }

      function clearedRatio() {
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var clear = 0, total = 0;
        for (var i = 3; i < data.length; i += 64) { total++; if (data[i] === 0) clear++; }
        return total ? clear / total : 0;
      }

      canvas.addEventListener('pointerdown', function (e) {
        if (!ctx) return;
        scratching = true;
        if (canvas.setPointerCapture) canvas.setPointerCapture(e.pointerId);
        lastPoint = null;
        scratchAt(e);
      });
      canvas.addEventListener('pointermove', function (e) { if (scratching) scratchAt(e); });
      ['pointerup', 'pointercancel'].forEach(function (t) {
        canvas.addEventListener(t, function () { scratching = false; });
      });
      /* Keyboard users scratch it all at once */
      canvas.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
        reveal();
      });

      function reveal() {
        if (revealed) return;
        revealed = true;
        root.classList.add('of-sp--revealed');
        title.textContent = 'Claim your discount';
        form.hidden = false;
        confetti();
        setTimeout(function () {
          if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            input.focus({ preventScroll: true });
          }
        }, 400);
      }

      function confetti() {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var colors = ['#2f7470', '#f5b301', '#e4572e', '#76b041', '#3a86ff'];
        for (var i = 0; i < 36; i++) {
          var c = document.createElement('span');
          c.className = 'of-sp__confetti';
          c.style.left = (35 + Math.random() * 30) + '%';
          c.style.background = colors[i % colors.length];
          c.style.setProperty('--x', (Math.random() * 360 - 180) + 'px');
          c.style.setProperty('--y', (Math.random() * 220 - 160) + 'px');
          c.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
          panel.appendChild(c);
          setTimeout(c.remove.bind(c), 1400);
        }
      }

      /* Submit to Shopify's native newsletter form. */
      form.addEventListener('submit',function(e){
        if(!input.checkValidity()){e.preventDefault();input.reportValidity();return;}
        set('sessionStorage','hs_sp_pending','1');
        submit.disabled=true;
      });

      function showError(msg) {
        error.textContent = msg;
        error.hidden = !msg;
        input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      }

      function onSubscribed(email) {
        subscribed = true;
        set('localStorage', KEYS.subscribed, '1');
        offer.hidden = true;
        success.hidden = false;
        success.querySelector('[data-of-sp-copy]').focus({ preventScroll: true });

        /* Extras: each one is optional and can't block the success screen */
        try {
          fetch(root.dataset.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(root.dataset.code), {
            credentials: 'same-origin',
            redirect: 'manual'
          }).catch(function () {});
        } catch (err) {}
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('of_scratch_popup_lead', {});
          }
        } catch (err) {}
      }

      /* ---- Copy code ---- */

      root.querySelector('[data-of-sp-copy]').addEventListener('click', function () {
        var btn = this;
        var code = root.dataset.code;
        var done = function () { btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = 'Copy'; }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, function(){btn.textContent='Select the code to copy';});
        } else {
          var t = document.createElement('textarea');
          t.value = code;
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.opacity = '0';
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); } catch (err) {}
          t.remove();
          done();
        }
      });

      /* ---- Keep the card centred in the visible area, also with the keyboard open ---- */

      function onViewport() {
        var vv = window.visualViewport;
        var h = vv ? vv.height : window.innerHeight;
        if (vv) {
          root.style.setProperty('--of-sp-top', vv.offsetTop + 'px');
          root.style.setProperty('--of-sp-vh', vv.height + 'px');
        }
        root.classList.toggle('of-sp--short', h < 620);
      }
      function watchViewport(on) {
        var fn = on ? 'addEventListener' : 'removeEventListener';
        if (window.visualViewport) {
          visualViewport[fn]('resize', onViewport);
          visualViewport[fn]('scroll', onViewport);
        } else {
          window[fn]('resize', onViewport);
        }
        if (on) onViewport();
      }
      if(postSuccess){set('sessionStorage','hs_sp_pending','0');open();onSubscribed(null);}
      else if(postError){open();reveal();}
      input.addEventListener('focus', function () {
        setTimeout(function () { input.scrollIntoView({ block: 'nearest' }); }, 300);
      });
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-article"]) return;
  try {
    
document.querySelectorAll('[data-hs-share]').forEach(button=>button.addEventListener('click',async()=>{const data={title:button.dataset.title,url:button.dataset.url};try{if(navigator.share){await navigator.share(data);}else{await navigator.clipboard.writeText(data.url);const status=button.parentElement.querySelector('[data-share-status]');status.classList.remove('visually-hidden');}}catch(error){if(error.name!=='AbortError')window.prompt(button.textContent.trim(),data.url);}}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-collection"]) return;
  try {
    
document.querySelectorAll('[data-hs-collection-form] select').forEach(select=>select.addEventListener('change',()=>select.form.requestSubmit()));

  } catch(e) { console.error(e); }
})();
})();
